import { defineStore } from "pinia";
import { backgroundDataToCssVars } from "@/Helpers/backgroundCss";
import { resolveThemeContent, resolveBackgroundData, resolveColourValue } from "@/Helpers/themeColourResolver";

export const usePlaylistStore = defineStore("playlist", {
    state: () => ({
        browserName: "",
        browserVersion: "",
        isMobileDevice: false,
        scrollDisabled: false,
        fontScale: 1,
        screenHeight: 0,
        targetScrollTop: 0,
        orientation: "portrait-primary",
        currentSlideIndex: 0,
        cards: [],
        previousAnswers: [],
        previousNudges: [],
        previousReflections: [],
        playlistId: 0,
        playlistTitle: "",
        isGuest: false,
        isPlaylistComplete: false,
        s3BucketURL: "",
        s3Region: "",
        brand: null,
        isShowingFullscreenVideo: false,
        certificatesUrl: null,
    }),
    getters: {
        get_playlistId() {
            return this.playlistId;
        },
        get_playlistTitle() {
            return this.playlistTitle;
        },
    },
    actions: {
        setBrand(brand) {
            this.brand = brand;
        },
        setInitalCards(cards) {
            this.cards = cards;
            this.cards.forEach((card) => {
                card.rows.forEach((row) => {
                    if (typeof row.content !== "object")
                        row.content = JSON.parse(row.content);
                });
                if (
                    card.theme?.content &&
                    typeof card.theme.content === "string"
                ) {
                    card.theme.content = JSON.parse(card.theme.content);
                }
                if (card.theme?.content) {
                    const shift = card.colour_shift || 0;
                    const resolved = resolveThemeContent(card.theme.content, this.brand, shift);
                    let cardThemeCss = "";
                    Object.entries(resolved).forEach(
                        ([key, value]) => {
                            if (key === "background_data" || key === "version") return;
                            if (key === "font") {
                                if (value !== '' && value !== null && value !== undefined) {
                                    const sanitisedValue = value.replace(/\_/g,' ');
                                    cardThemeCss += "--font: '" + sanitisedValue + "';";
                                }
                            } else if (key === "heading_font") {
                                if (value !== '' && value !== null && value !== undefined) {
                                    const sanitisedValue = value.replace(/\_/g,' ');
                                    cardThemeCss += "--heading-font: '" + sanitisedValue + "';";
                                }
                            } else if (key === "bg_image") {
                                if (value) {
                                    const url = this.s3BucketURL
                                        ? "https://" + this.s3BucketURL + '.s3.' + this.s3Region + '.amazonaws.com' + value
                                        : value;
                                    cardThemeCss += "--" + key + ": url('" + url + "');";
                                }
                            } else if (typeof value === 'string') {
                                cardThemeCss += "--" + key + ": " + value + ";";
                            }
                        }
                    );
                    // Apply theme-level background_data
                    const themeBgCss = backgroundDataToCssVars(resolved.background_data, this.s3BucketURL, this.s3Region);
                    if (themeBgCss) cardThemeCss += themeBgCss;
                    card.theme.css = cardThemeCss;
                }
                // Apply per-card custom background override
                const resolvedCardBg = resolveBackgroundData(card.background_data, this.brand, card.colour_shift || 0);
                const bgCss = backgroundDataToCssVars(resolvedCardBg, this.s3BucketURL, this.s3Region);
                if (bgCss) {
                    if (!card.theme) card.theme = {};
                    card.theme.css = (card.theme.css || '') + bgCss;
                }
                // Apply per-card text colour override
                if (card.text_colour_override) {
                    const overrideHex = resolveColourValue(card.text_colour_override, this.brand, card.colour_shift || 0);
                    if (overrideHex) {
                        if (!card.theme) card.theme = {};
                        card.theme.css = (card.theme.css || '') + '--card_text: ' + overrideHex + ';';
                    }
                }
            });
        },
        setPlaylistId(id) {
            this.playlistId = id;
        },
        setPlaylistTitle(title) {
            this.playlistTitle = title;
        },
        setPlaylistCertificatesEnabled(isEnabled) {
            this.playlistCertificatesEnabled = isEnabled;
        },
        setPlaylistCertificateIntervalDays(days) {
            this.playlistCertificateIntervalDays = days;
        },
        setCertificatesUrl(url) {
            this.certificatesUrl = url;
        },
        setIsGuest(isGuest) {
            this.isGuest = isGuest;
        },
        setIsPlaylistComplete(isComplete) {
            this.isPlaylistComplete = isComplete;
        },
        setPreviousAnswers(answers) {
            this.previousAnswers = answers;
        },
        setPreviousNudges(nudges) {
            this.previousNudges = nudges;
        },
        setPreviousReflections(reflections) {
            this.previousReflections = reflections;
        },
        setBrowserName(name) {
            this.browserName = name;
        },
        setBrowserVersion(version) {
            this.browserVersion = version;
        },
        setIsMobileDevice(isMobile) {
            this.isMobileDevice = isMobile;
        },
        setScrollDisabled(disabled) {
            this.scrollDisabled = disabled;
        },
        setFontScale(scale) {
            this.fontScale = scale;
        },
        setOrientation(orientation) {
            this.orientation = orientation;
        },
        setCurrentSlideIndex(index) {
            this.currentSlideIndex = index;
        },
        getPreviousAnswer(rowID) {
            let answer = null
            const answers = this.previousAnswers.filter((item) => item.rowID === rowID);
            if (answers.length > 0) answer = answers[0].answer;
            return answer;
        },
        getPreviousReflection(rowID) {
            let answer = null
            const reflections = this.previousReflections.filter((item) => item.rowID === rowID);
            if (reflections.length > 0) answer = reflections[0].answer;
            return answer;
        }
    },
});
